module.exports = __webpack_public_path__ + "static/img/comsoft-graphics-2.f4c476c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/comsoft-graphics-2.png
// module id = okFv
// module chunks = 1